import React from 'react';
import { Descriptions } from 'antd';
import moment from 'moment';
import t from './translate';

function getAge(birthDate) {
  return moment().diff(birthDate, 'years');
}

export default function PatientInformation({ patient }) {
  const [name] = patient.name;
  const [lastName, secondLastName] = name.family.split(' ');
  return (
    <Descriptions>
      <Descriptions.Item label="Nombre">
        {name.given.join(' ')}
      </Descriptions.Item>
      <Descriptions.Item label="Apellido Paterno">
        {lastName}
      </Descriptions.Item>
      <Descriptions.Item label="Apellino Materno">
        {secondLastName}
      </Descriptions.Item>
      <Descriptions.Item label="Edad">
        {getAge(patient.birthDate)}
      </Descriptions.Item>
      <Descriptions.Item label="F. Nacimiento">
        {patient.birthDate}
      </Descriptions.Item>
      <Descriptions.Item label="Género">
        {t(patient.gender, patient.gender)}
      </Descriptions.Item>
    </Descriptions>
  );
}
